<script>
export default {
  name: 'FormEditor',
  components: {
    EditorFroala: () => import('./EditorFroala.vue'),
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<template>
  <EditorFroala
    :value="value"
    :config="config"
    class="f-c-editor"
    :tag="tag"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  />
</template>
<style lang="scss">
  .f-c-editor {
    .fr-wrapper {
      height: 400px;
      overflow: auto;
    }
    .fr-toolbar{
      border-top: none;
    }
  }
</style>
